export default __webpack_public_path__ + "static/media/2.73948584.png";